import { Card, CardContent } from "@/components/ui/card";
import { Settings } from "lucide-react";

export default function AdminSettings() {
  return (
    <div className="p-6 lg:p-8 max-w-4xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-[#0F172A] flex items-center gap-2" data-testid="admin-settings-title">
          <Settings className="w-6 h-6 text-[#1B4D3E]" strokeWidth={1.5} />
          Configuracion
        </h1>
        <p className="text-sm text-[#64748B] mt-1">Configuracion general de la plataforma</p>
      </div>
      <Card className="card-default">
        <CardContent className="py-16 text-center">
          <Settings className="w-12 h-12 text-[#64748B] mx-auto mb-4 opacity-40" strokeWidth={1.5} />
          <p className="text-[#64748B] font-medium mb-1">Modulo en desarrollo</p>
          <p className="text-sm text-[#94A3B8]">Proximamente podras ajustar la configuracion global de cadii.</p>
        </CardContent>
      </Card>
    </div>
  );
}
